import {
  isAfter,
} from "date-fns"
import _ from "lodash"

// test: yarn test src/models/__tests__/Coupon.model.spec.js
class Coupon {
  constructor (rawData) {
    this._rawData = rawData
  }

  hasStarted() {
    if (!this._rawData.start_at) {
      return true
    }
    return isAfter(new Date(), new Date(this._rawData.start_at))
  }

  hasEnded() {
    if (!this._rawData.end_at) {
      return false
    }
    return isAfter(new Date(), new Date(this._rawData.end_at))
  }

  isInRedeemableTimeRange() {
    return this.hasStarted() && false === this.hasEnded()
  }

  get isEnabledByAdministrator() {
    return !!_.get(this._rawData, 'is_enabled', true)
  }

  get wasRedeemed() {
    return !!this._rawData.redeem_at
  }

  get isRedeemable() {
    return this.isEnabledByAdministrator && this.isInRedeemableTimeRange() && !this.wasRedeemed
  }

  get unredeemableReason() {
    if (this.wasRedeemed) {
      return "已使用";
    } else if (!this.isEnabledByAdministrator) {
      return "尚未啟用";
    } else if (!this.hasStarted()) {
      return "尚未開始";
    } else if (this.hasEnded()) {
      return "已過期";
    }
  }
}

export default Coupon
